<template lang="pug">
  include /mixins
  renderer(
    v-if="response.items"
    :result="response.items"
  )
</template>

<script>
import Renderer from '@app/List/Renderer'
import sliderControl from '@utils/slider-controls'
import {
  lastViewedProductSliderResource,
  recommendedProductSliderResource,
} from '@api/marketing-tools.service'
import {
  relatedProductSliderResource,
  productVariantAnalogsSliderResource,
  productVariantSetsliderResource,
  productVariantSetItemsSliderResource,
  productVariantConsumablesSliderResource,
} from '@api/catalog.service'

const RESOURCES_MAP = {
  last_viewed: lastViewedProductSliderResource,
  recommended: recommendedProductSliderResource,
  related: relatedProductSliderResource,
  variant_analogs: productVariantAnalogsSliderResource,
  sets: productVariantSetsliderResource,
  set_items: productVariantSetItemsSliderResource,
  consumables: productVariantConsumablesSliderResource,
}

export default {
  components: {
    Renderer,
  },

  props: {
    target: {
      type: String,
    },
    params: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      response: {
        items: null,
      },
    }
  },

  async created() {
    await this.getData()

    await this.$nextTick()

    sliderControl('js-ajax-slider-box')
  },

  methods: {
    async getData() {
      const resource = RESOURCES_MAP[this.target]
      const params = { ...this.params }

      const res = await resource.execute(params)

      this.response = res.data
    },
  },
}
</script>
